import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import ProductContext from "../memory/ProductContext";
import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { resetAddProductRes } from "../reducer/productSlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const productContext = useContext(ProductContext);
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);

  useEffect(() => {
    productContext?.setPages({
      startPage: GENERAL.startPage,
    });
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  useEffect(() => {
    store.dispatch(resetAddProductRes());
  }, []);

  useEffect(() => {
    if (done) {
      productContext?.setPages({
        startPage: GENERAL.startPage,
      });
    }
  }, [done]);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
